/**
 * Returns an array of instances which are mapped by keys in the `domainMap`.
 * The `domainList` provide the instances' keys.
 * NOTE: this function preservers the order of the given keys.
 *
 * @param   {Object} domainMap
 * @param   {String[]|Number[]} domainListData
 * @returns {Instance[]}
 */
function getInstancesFromMapReduxUtil (domainMap, domainListData) {
  if (!Array.isArray(domainListData)) {
    return []
  }
  return domainListData.reduce((instances, instanceKey) => {
    const instance = domainMap[instanceKey]
    if (instance) {
      instances.push(domainMap[instanceKey])
    }
    return instances
  }, [])
}

export default getInstancesFromMapReduxUtil
